import Loadable from 'react-loadable'
import Loading from '../../components/Loading/Loading'

const RequestConfirmation = Loadable({
  loader: () => import('./containers/RequestConfirmationContainer'),
  loading: Loading,
})

export default {
  path: '/request-confirmation/:uuid',
  component: RequestConfirmation,
}



// WEBPACK FOOTER //
// ./src/routes/requestConfirmation/index.js